module.exports = __webpack_public_path__ + "images/kihnu/apple-icon-76x76.png";